import { BoxV2, Checkbox } from 'sonata-react-components';
import { DeviceOs as DeviceOsType } from 'sonata-static-storage/lib/common/common.types';

import { OsStyled } from './Os.styled';
import { OsSelection } from './OsSelection';

type Props = {
  getDeviceOs: () => Promise<DeviceOsType[]>;
  id: string;
  onDeviceOsChanged: (selectedDeviceOs: DeviceOsType[]) => void;
  onUnknownIncludedToggled: (unknownIncluded: boolean) => void;
  selectedDeviceOs: DeviceOsType['os'][];
  unknownIncluded: boolean;
  unknownIncludedPermission: boolean;
};

export function Os({
  getDeviceOs,
  id,
  onDeviceOsChanged,
  onUnknownIncludedToggled,
  selectedDeviceOs,
  unknownIncluded,
  unknownIncludedPermission
}: Readonly<Props>) {
  const handleDeviceOsOnChanged = (newDeviceOs: DeviceOsType[]) => {
    onDeviceOsChanged?.(newDeviceOs);
  };

  const handleUnknownIncludedToggled = (_id: string, checked: boolean) => {
    onUnknownIncludedToggled(checked);
  };

  return (
    <OsStyled className="targetingDeviceOsContainer">
      <BoxV2 id={`${id}_device_os_box_container`}>
        <BoxV2.Body bgColor="transparent" padding="0">
          <OsSelection
            getDeviceOs={getDeviceOs}
            id={`${id}_device_os_selector`}
            onChangeDeviceOs={handleDeviceOsOnChanged}
            selectedDeviceOs={selectedDeviceOs}
          />
          {unknownIncludedPermission && selectedDeviceOs.length > 0 && (
            <div className="targetingDeviceOsContainer__unknownIncluded">
              <Checkbox
                defaultActive={unknownIncluded}
                id={`${id}_unknownIncluded`}
                labelText="Unknown Included"
                onClickAction={handleUnknownIncludedToggled}
              />
            </div>
          )}
        </BoxV2.Body>
      </BoxV2>
    </OsStyled>
  );
}
